import { GrowthBook } from '@growthbook/growthbook';
import { autoAttributesPlugin } from '@growthbook/growthbook/plugins';
import { getEnv, getEnvBoolean } from '../utils/env';

export const growthbook = new GrowthBook({
  apiHost: 'https://cdn.growthbook.io',
  clientKey: getEnv('GROWTHBOOK_CLIENT_KEY'),
  enableDevMode: getEnvBoolean('GROWTHBOOK_ENABLE_DEV_MODE'),
  trackingCallback: (experiment, result) => {
    // This is where you would send an event to your analytics provider
    console.log('Viewed Experiment', {
      experimentId: experiment.key,
      variationId: result.key,
    });
  },
  // autoAttributesPlugin uses browser APIs and throws if instantiated on the server.
  // Consumers (e.g. superserve-ui) can load this module during Next.js SSR/prerender via the package entry, so skip in Node.
  plugins: typeof window !== 'undefined' ? [autoAttributesPlugin()] : [],
});
